import React from 'react';
import PropTypes from 'prop-types';
import styles from './Input.module.scss';

const Input = ({
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  id,
  className,
  ...rest
}) => {
  const wrapperClasses = [styles.wrapper, className || ''].filter(Boolean).join(' ');
  const inputClasses = [
    styles.input,
    leftIcon ? styles.hasLeftIcon : '',
    rightIcon ? styles.hasRightIcon : '',
    error ? styles.inputError : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClasses}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.inputWrap}>
        {leftIcon && <span className={styles.leftIcon}>{leftIcon}</span>}
        <input id={id} className={inputClasses} {...rest} />
        {rightIcon && <span className={styles.rightIcon}>{rightIcon}</span>}
      </div>
      {error && <span className={styles.error}>{error}</span>}
      {!error && helperText && <span className={styles.helperText}>{helperText}</span>}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
};

Input.defaultProps = {
  label: '',
  error: '',
  helperText: '',
  leftIcon: null,
  rightIcon: null,
  id: undefined,
  className: '',
};

export default Input;
